<script lang="ts">
/**
 * This mixin is just for props that are used for field-group fields.  This helps them
 * be consistent with the props of it's parents (text-field selectbox, etc)
 */
export default {
  props: {
    errorText: String,
    hintText: String,
    hintTextAboveField: Boolean,
    label: String,
    labelId: String,
    id: String,
    describedbyId: String, // aria-describedby for field, id for hint text
    required: { type: Boolean, default: false }
  },
  computed: {
    describedbyIdValue() {
      return this.errorText || this.hintText ? this.describedbyId : null
    }
  }
}
</script>
